import { Injectable } from '@angular/core';
import { isEmpty } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ArrayUtil {

    constructor(
    
    ) { }

    toString( arr: string[] ){
        let output = ""
        for( let i = 0 ; i < arr.length ; i++ ){
            const str = arr[i]
            output += str 
            if ( i != arr.length - 1 ) 
                output += ","
        }
        return output 
    }

}
